export default {
  props: {
    isGrouping: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {};
  },
  computed: {
    isGroupingObject() {
      return this.isGrouping;
    }
  },
  methods: {
    /**
     * Emit to back value to parent
     */
    onClick() {
      this.$emit('change', !this.isGroupingObject);
    }
  }
};
